
export const callTime = time => { // 秒数向上取整
  let h = String((time / 1000 / 60 / 60) | 0)
  let m = Math.ceil(((time - h * 1000 * 60 * 60) / 60000)) + ''
  return h.padStart(2, 0) + ':' + m.padStart(2, 0)
}

export const callTimeFn = time => { // 秒数向下取整
  let h = String((time / 1000 / 60 / 60) | 0)
  let m = String(((time - h * 1000 * 60 * 60) / 1000 / 60) | 0)
  return h.padStart(2, 0) + ':' + m.padStart(2, 0)
}

export const callTimeCount = (mss) => {
  var days = parseInt(mss / (1000 * 60 * 60 * 24))
  var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
  var seconds = (mss % (1000 * 60)) / 1000
  return days + ' 天 ' + hours + ' 小时 ' + minutes + ' 分钟 ' + seconds + ' 秒 '
}

export const getClassStatus = (st, et) => {
  let now = new Date().getTime()
  // 课程时间
  let startTime = new Date(st).getTime()
  let endTime = new Date(et).getTime()
  let Stype = startTime - now
  let Etype = endTime - now
  if (Stype < 0 && Etype > 0) {
    return 2
  } else if (Stype < 0 && Etype < 0) {
    return 3
  } else {
    return 1
  }
}


export const parseTime = (msecond,isMis=true) => {
  let step=isMis?1000:1;
  const time=parseInt((msecond||'0').toString());
  const hour=Math.floor(time/(3600*step));
  const minite=Math.floor((time%(3600*step))/(60*step));
  const second=Math.floor((time%(60*step))/step);
  const arr=[fixed(hour),fixed(minite),fixed(second)]
  return arr.join(':')
}
const fixed=(num)=>{
  if(num<10){
      return '0'+num;
  }
  return num.toString()
}



// WEBPACK FOOTER //
// ./src/utils/callTime.js